"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Text = require("../Text/Text");
var _CheckboxGroupModule = _interopRequireDefault(require("./CheckboxGroup.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Type definitions for checkbox child props

// Type for onChange handler parameters

const CheckboxGroup = exports.CheckboxGroup = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    align = 'vertical',
    disabled = false,
    name,
    value: checkedList,
    onChange,
    classNames,
    error = false,
    errorText = '',
    children,
    testId
  } = _ref;
  const onChangeHandler = _ref2 => {
    let {
      value,
      checked
    } = _ref2;
    const checkedListTemp = checkedList ? [...checkedList] : [];
    if (checked && !checkedListTemp.includes(value)) {
      checkedListTemp.push(value);
    } else if (!checked && checkedListTemp.includes(value)) {
      for (let i = 0; i < checkedListTemp.length; i++) {
        if (checkedListTemp[i] === value) {
          checkedListTemp.splice(i, 1);
          break;
        }
      }
    }
    onChange?.(checkedListTemp);
  };
  const childrenWithProps = React.Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child)) {
      const {
        value,
        disabled: disabledChild,
        error: errorChild,
        onChange
      } = child.props;
      const childOnChange = params => {
        onChangeHandler(params);
        onChange?.(params);
      };
      return /*#__PURE__*/React.cloneElement(child, {
        name,
        checked: !!checkedList?.includes(value),
        onChange: childOnChange,
        align,
        error: errorChild || error,
        disabled: disabledChild || disabled,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'checkbox',
          index: value
        })
      });
    }
    return child;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classify.default)(_CheckboxGroupModule.default.checkboxGroupContainer, classNames?.wrapper),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)({
        [_CheckboxGroupModule.default.vertical]: align === 'vertical',
        [_CheckboxGroupModule.default.horizontal]: align === 'horizontal-fixed',
        [_CheckboxGroupModule.default.horizontalFluid]: align === 'horizontal-fluid'
      }, classNames?.checkboxGroup),
      ref: forwardRef,
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'group'
      }),
      children: childrenWithProps
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodySmall, {
      className: (0, _classify.default)(classNames?.errorText),
      color: "danger",
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'error'
      }),
      children: errorText
    })]
  });
});